<n-data-table
    #dt
    [columnDefs]="tableColumnDefs"
    [config]="tableConfig"
    [data]="data"
    [loading]="loading"
    id="host-detail-initiator-table">
</n-data-table>
